export default {
  path: '/machine_models',
  name: 'machine_models',
  component: () => import('../components/machinemodel/Layout'),
  redirect: { name: 'MachineModelList' },
  meta: {
    breadcrumb: 'profile.machine.models',
  },
  children: [
    {
      name: 'MachineModelList',
      path: '',
      component: () => import('../views/machinemodel/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MachineModelCreate',
      path: 'new',
      component: () => import('../views/machinemodel/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MachineModelUpdate',
      path: ':id/edit',
      component: () => import('../views/machinemodel/Update'),
      meta: {
        breadcrumb: 'profile.machine.model',
      },
    },
    {
      name: 'MachineModelShow',
      path: ':id',
      component: () => import('../views/machinemodel/Show'),
      meta: {
        breadcrumb: 'profile.machine.model',
      },
    }
  ]
};
